import React from "react";
import { Box, Typography } from "@mui/material";
import { RawNoteStatus, NOTE_STATUS_LABEL, NOTE_STATUS_COLOUR } from "../../hooks/usePastoralNotes";

/**
 * Small status pill for a note's lifecycle status (a coloured dot + label).
 * Shared by the grid rows and the note drawer so both render identically.
 * Renders nothing when the note has no status.
 */
const NoteStatusChip: React.FC<{ status?: RawNoteStatus; size?: "sm" | "md" }> = ({ status, size = "sm" }) => {
	if (!status) return null;
	const colour = NOTE_STATUS_COLOUR[status];
	const label = NOTE_STATUS_LABEL[status];
	const dot = size === "md" ? 8 : 7;
	const font = size === "md" ? 12 : 11;
	return (
		<Box display="inline-flex" alignItems="center" gap={0.5} sx={{ px: 0.75, py: 0.25, borderRadius: 1, bgcolor: `${colour}14` }}>
			<Box sx={{ width: dot, height: dot, borderRadius: "50%", bgcolor: colour, flexShrink: 0 }} />
			<Typography fontSize={font} fontWeight={600} sx={{ color: colour, lineHeight: 1 }}>{label}</Typography>
		</Box>
	);
};

export default NoteStatusChip;
